<!-- eslint-disable -->
<template lang="pug">
    game-preparation-counter(v-if="counter < 4 && !isGamePaused", :counter="counter" :players-number="playersNumber")
    .play-box(v-else, :class=`[{'multiplayer-play-box': playersNumber >= 1}, multiplayerClass]`)
        modal-frame-for-individual-settings(
            v-if="showModalFrame",
            @close="showModalFrame = false",
            :player-name="parameters && parameters.playerName",
            :current-user-position="place - 1",
            @parametersUpdate="handleParametersUpdate",
            :slug="type",
        )
        game-header(
            v-if="!inPuzzle && !isBattle",
            @soundStateChanged="headerKey = !headerKey",
            :key="headerKey",
            :slug="type",
            game-type="mentalArithmetic",
            :is-homework="!!exerciseId",
            :amount-of-actions="amountOfActionParameterForHeader"
        )
        .play-box__game(:class="{'play-box__game_x2': isX2}")
            .play-box__answer-footer-x2(v-if='isX2 && !showTurtle && counter === 4')
                portal-target(v-if='isSingleScreen && isX2 && ((!gameEnd && correct !== null) || gameEnd)', name='exitButtons')
                cs-button(
                    color="blue",
                    type="button",
                    v-if='correct === null',
                    @click='sendAnswer'
                )
                    | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
            .play-box__example(:class="{'play-box__example_x2': isX2}")
                digits-area(
                    :is-battle="isBattle"
                    :key="parametersChangerCounter"
                    :parameters="parameters"
                    :is-x2="isX2"
                    area-index="first"
                    :show-problem="showProblem"
                    :stop-game="stopGame"
                    :is-started="isStarted"
                    :exercise-id="exerciseId"
                    :show-cartoon='true'
                    :is-single-screen="isSingleScreen"
                    :min-duration-for-voice-acting="minDurationForVoiceActing"
                    :get-last-numbers="getLastNumbers"
                    :answer-duration="answerDuration"
                    @answer="checkAnswer"
                    @stopGame="stopGameEvent"
                    @showTurtle="$emit('showTurtle', $event)"
                    @enterKeyUp="sendAnswer"
                    ref="leftDigitsArea"
                    @start="isLoaded = true"
                    @finish="isLoaded = false"
                    @index="showedActions = $event"
                    @exampleEnded="exampleEnded"
                    :examples-array="examplesArray"
                    :check-multiplayer-answers="checkMultiplayerAnswers"
                    @clearTimer="clearTimer"
                    :is-abacus-opened="showAbacus"
                    @opponentNumbers="opponentNumbers = $event"
                    :is-game-paused="isGamePaused"
                    :players-number="playersNumber"
                    :color-for-student="colorForStudent"
                    :index-of-play-box="place - 1"
                    :game-end="gameEnd"
                    @displayNumbers="displayNumbers = $event"
                )
                hr.play-box__example-divider(v-if="isX2")
                .play-box__example_second(v-if="isX2")
                    digits-area(
                        :is-battle="isBattle"
                        :parameters="parameters"
                        :is-x2="isX2"
                        area-index="second"
                        :show-problem="showProblem"
                        :stop-game="stopGame"
                        :is-started="isStarted"
                        :exercise-id="exerciseId"
                        :show-cartoon='false'
                        :is-single-screen="isSingleScreen"
                        :delay='250*parameters.speed'
                        :get-last-numbers="getLastNumbers"
                        :answer-duration="answerDuration"
                        @answer="checkAnswer"
                        @stopGame="stopGameEvent"
                        @showTurtle="$emit('showTurtle', $event)"
                        @enterKeyUp="sendAnswer"
                        ref="rightDigitsArea"
                        :check-multiplayer-answers="checkMultiplayerAnswers"
                        :is-abacus-opened="showAbacus"
                        :is-game-paused="isGamePaused"
                    )
            .game-info__container(v-if="isLoaded || playersNumber >= 1 || isBattle")
                .game-info__block
                    game-info(
                        :score="{left: !isBattle ? answers.good : userScore, right: !isBattle ? answers.bad : opponentScore}",
                        :time="getTime",
                        :time-with-hours="getTimeWithHours",
                        :mode="parameters && parameters.mode",
                        :game-difficult="gameDifficultForAbacus",
                        :is-x2="isX2",
                        :multiplayer-mode="playersNumber >= 1",
                        :player-name="parameters && parameters.playerName",
                        :players-number="playersNumber",
                        :place="place",
                        :color-for-student="colorForStudent",
                        :display-game-info="(!displayNumbers && correct === null || isGamePaused)",
                        @openModalFrame="showModalFrame = true",
                        :is-game-paused="isGamePaused",
                        :is-olympiad="isOlympiad"
                        :slug="type",
                        @parametersUpdate="handleParametersUpdate",
                        @showAbacus="isAbacusOpened",
                        :is-from-battle="isBattle",
                        :parameters="parameters",
                        :initial-speed="initialSpeed",
                        :opponent="opponent",
                        :opponent-numbers="opponentNumbers",
                        :is-opponent-answering="isOpponentAnswering",
                        :showed-actions="showedActions",
                        :speed="showSpeed && parameters.speed"
                    )
        calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        portal(:to='portalName', v-if='isSingleScreen || playersNumber >= 1')
            template(v-if='!gameEnd')
                template(v-if='correct !== null')
                    .add-sub-with-time__bottom-button.add-sub-with-time__bottom-button_two-buttons(v-if='!correct')
                        .add-sub-with-time__show-answer-button
                            cs-button(
                                type="button",
                                color="blue",
                                pattern="primary-outline",
                                v-if='!showProblem && !isOlympiad',
                                @click='showProblem = true'
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_showProblem') }}
                        div(v-if="playersNumber >= 1")
                            cs-button(
                                :key="showProblem",
                                type="button",
                                color="blue",
                                v-focus='true',
                                @click='refreshGame'
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                        div(v-else)
                            cs-button(
                                :key="showProblem",
                                type="button",
                                color="blue",
                                v-focus="true",
                                @click="repeatGame"
                            )
                                | {{ $i18n.t('trainer.trainer_games_tryAgain') }}
                    .add-sub-with-time__bottom-button.add-sub-with-time__bottom-button_two-buttons(v-else)
                        .add-sub-with-time__show-answer-button
                            cs-button(
                                type="button",
                                color="blue",
                                pattern="primary-outline",
                                v-if='!showProblem && !isOlympiad',
                                @click='showProblem = true'
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_showProblem') }}
                        div
                            cs-button(
                                :key="showProblem",
                                type="button",
                                color="blue",
                                v-focus='true',
                                @click='refreshGame'
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
            template(v-else)
                .add-sub-with-time__bottom-button.add-sub-with-time__bottom-button_three-buttons
                    result-buttons(
                        :exercise-id="exerciseId"
                        games-type="mentalArithmetic"
                        show-result-buttons
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        template(slot="mainButton")
                            cs-button(
                                v-if="!showProblem && !isOlympiad",
                                type="button",
                                color="blue",
                                @click="showProblem = true",
                                v-focus="true"
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_showProblem') }}
                .help-text__end-multiplayer-game(v-if="playersNumber")
                    | {{ $i18n.t('common.common_gameSettings_endGame') }}
</template>

<script>
    import MultiplayerPlayBoxMixin from '../../../../utils/multiplayer/playBoxMixin';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import trainerConfig from '../../../../config/trainer';
    import GameMixin from '../../../../utils/trainer/game';
    import timer from '../../../../utils/trainer/timer';
    import EndGameMixin from '../../../../utils/trainer/endGame';
    import * as minDurationForVoiceActing from '../../../../config/minDurationsForVoiceActing';
    import Battle from '../../../../utils/battle/battleMixin';

    import DigitsArea from './DigitsArea.vue';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';
    import GameInfo from '../GameInfo.vue';
    import GameHeader from '../../GameHeader.vue';
    import ResultButtons from '../ResultButtons.vue';
    import ModalFrameForIndividualSettings from '../ModalFrameForIndividualSettings.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import {
        counterHandler,
        getIsCheckAnswersButtonAvailableComputed,
        getIsCheckAnswersButtonAvailableWatcher,
    } from '../../../../utils/multiplayer/counterHandler';

    const MINIMAL_SPEED = 10;
    function DEFAULT_DATA() {
        return {
            counter: 0,
            correct: null,
            isStarted: false,
            parameters: null,
            answersForCurProblem: {
                good: 0,
                bad: 0,
            },
            correctAnswersForComplication: 0,
            wrongAnswersForComplication: 0,
            correctAnswersForSpeed: 0,
            wrongAnswersForSpeed: 0,
            isActive: false,
            gameEnd: false,
            stopGame: false,
            showProblem: false,
            getLastNumbers: false,
            loadedSound: 0,
            countdownInstance: null,
            bgMusicInstance: null,
            resultInstance: null,
            isLoaded: false,
            showedActions: 0,
            examplesArray: [],
            isExampleEnded: false,
            headerKey: false,
            showAbacus: false,
            showModalFrame: false,
            infinityModeCompleted: false,
            displayNumbers: false,
        };
    }

    export default {
        beforeDestroy() {
            if (this.bgMusicInstance) {
                this.bgMusicInstance.stop();
            }
            if (!this.inPuzzle) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        mixins: [GameMixin, timer, EndGameMixin, MultiplayerPlayBoxMixin, Battle],
        data() {
            return DEFAULT_DATA();
        },
        props: {
            exerciseId: {
                type: [Number, String],
                default: 0,
            },
            type: {
                type: String,
                default: '',
            },
            showTurtle: {
                type: Boolean,
                default: false,
            },
            gameType: {
                type: String,
                default: '',
            },
            answerDuration: {
                type: [String, Number],
                default: '',
            },
            playAgain: {
                type: Boolean,
                default: false,
            },
            inPuzzle: {
                type: Boolean,
                default: false,
            },
            isLastGameInBattle: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted() {
            this.fetchData()
                .then(() => {
                    this.$emit('setMotion', this.parameters.extraOptions.motion);
                    if (!this.isSingleScreen) {
                        this.isGamePaused = true;
                    } else if (this.soundObjects.length && !this.inPuzzle) {
                        this.$createjs.Sound.removeAllSounds();
                        this.$createjs.Sound.removeAllEventListeners();
                        this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                        this.$createjs.Sound.alternateExtensions = ['mp3'];
                        this.$createjs.Sound.registerSounds(this.soundObjects);
                    } else {
                        this.counter = 1;
                    }
                })
                .catch((e) => {
                    console.log(e);
                    this.counter = 1;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                });
        },
        watch: {
            refreshGameEvent: {
                handler() {
                    this.isGamePaused = true;
                    this.answers.good = 0;
                    this.answers.bad = 0;
                    this.correct = null;
                    this.correctAnswersForComplication = 0;
                    this.wrongAnswersForComplication = 0;
                    this.correctAnswersForSpeed = 0;
                    this.wrongAnswersForSpeed = 0;
                    this.examplesArray = [];
                    this.gameEnd = false;
                    this.stopTimer();
                    this.time = 0;
                },
            },
            continueGameEvent(val) {
                if (val && this.isAvailableExamplesToSolveAndTimeLimit) {
                    this.refreshGame();
                }
            },
            isCheckAnswersButtonAvailable: getIsCheckAnswersButtonAvailableWatcher.call(this, {
                emitCheckAnswersReadyEvent: true,
                triggerCounterHandler: true,
            }),
            isCounterStarted: counterHandler,
            correct(val) {
                if (this.isSingleScreen) {
                    this.$emit('playAgainReady', val !== null);
                } else {
                    let playBox = document.querySelectorAll('.play-box')[this.place - 1].parentElement;
                    if (playBox) {
                        if (val !== null && val) {
                            playBox.classList.add('play-box__correct-answer');
                        } else if (val !== null && !val) {
                            playBox.classList.add('play-box__incorrect-answer');
                        } else if (val === null) {
                            playBox.classList.remove('play-box__correct-answer');
                            playBox.classList.remove('play-box__incorrect-answer');
                        }
                    }
                }
            },
            gameEnd(val) {
                if (val) {
                    this.$emit('playAgainReady', !this.isSingleScreen);
                    if (this.inPuzzle) {
                        this.$emit('finish', this.answers, this.time);
                    }
                }
            },
            counter(val) {
                if (val < 4) {
                    this.preparation();
                } else {
                    this.isStarted = true;
                    if (!(this.isGamePaused || this.isSingleScreen)) {
                        this.setTimer();
                    }
                }
            },
            isLoaded(val) {
                if (val && !this.isGamePaused && this.playersNumber === 0) {
                    this.setTimer();
                }
            },
            playAgain(val) {
                if (
                    val &&
                    this.answers.good < this.parameters.amountOfExamples &&
                    !this.isLoaded &&
                    !this.counter &&
                    this.isExampleEnded
                ) {
                    this.refreshGame();
                }
            },
            multiplayerGamesState(value) {
                if (value && !this.gameEnd) {
                    this.isGamePaused = value === 'paused';
                }
            },
            isGamePaused(value) {
                if (!value) {
                    this.counter = 1;
                    this.stopGame = false;
                } else {
                    this.stopTimer();
                    this.stopGame = true;
                    this.correct = null;
                }
            },
            parametersChangerCounter() {
                if (!this.gameEnd) {
                    this.time = 0;
                    this.correct = null;
                }
                this.fetchData();
            },
        },
        methods: {
            exampleEnded(numbers) {
                if (!numbers) {
                    this.isExampleEnded = true;
                    return;
                }
                this.examplesArray.push(numbers);
                if (this.parameters.dictation) {
                    if (!this.isGameEnded) {
                        this.stopGame = false;
                        this.clearTimer();
                    }
                } else {
                    clearTimeout(this.timer);
                }
                if (this.isGameEnded) {
                    this.gameEnd = true;
                    return;
                }
                this.refreshGame();
            },
            refreshGame() {
                this.showProblem = false;
                this.isStarted = false;
                this.stopGame = false;
                this.correct = null;
                this.counter = 1;
                if (this.parameters.dictation) {
                    if (this.parameters.isComplication) {
                        this.complicate();
                    }
                    if (this.parameters.isSpeedIncrease) {
                        this.increaseSpeed();
                    }
                }
            },
            repeatGame() {
                this.showProblem = false;
                this.isStarted = false;
                this.correct = null;
                this.counter = 1;
            },
            sendAnswer() {
                this.answersForCurProblem.bad = 0;
                this.answersForCurProblem.good = 0;
                if (this.$refs.leftDigitsArea.answer !== '') {
                    if (this.$refs.rightDigitsArea) {
                        if (this.$refs.rightDigitsArea.answer !== '') {
                            this.$refs.leftDigitsArea.checkAnswer();
                            this.$refs.rightDigitsArea.checkAnswer();
                        }
                    } else {
                        this.$refs.leftDigitsArea.checkAnswer();
                    }
                }
            },
            preparation() {
                if (this.isSingleScreen) {
                    this.countdownInstance = this.$createjs.Sound.play('beep');
                    this.countdownInstance.volume = 0.6;
                }
                setTimeout(() => {
                    this.counter += 1;
                }, 1000);
            },
            checkAnswer(isRight) {
                if (this.isX2) {
                    isRight ? this.answersForCurProblem.good++ : this.answersForCurProblem.bad++;
                    if (this.answersForCurProblem.good + this.answersForCurProblem.bad === 2) {
                        this.answersForCurProblem.good === 2 ? this.correctAnswer() : this.wrongAnswer();
                        this.handleAnswer();
                    }
                } else {
                    isRight ? this.correctAnswer() : this.wrongAnswer();
                    this.handleAnswer();
                }
            },
            handleAnswer() {
                if (this.parameters.isSpeedIncrease) {
                    this.increaseSpeed();
                }
                if (this.parameters.isComplication) {
                    this.complicate();
                }
                if (
                    (this.isBattle || this.isOlympiad) &&
                    this.answers.good + this.answers.bad >= this.parameters.amountOfExamples
                ) {
                    this.gameEnd = true;
                }
                if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                    this.sendStat(this.correct);
                }
                if (this.isOlympiad) {
                    this.repeatGame();
                }
            },
            correctAnswer() {
                !this.isOlympiad && this.playResultSound('success');
                ++this.answers.good;
                this.correct = true;
                this.getLastNumbers = false;
                this.clearTimer();
                if (
                    !this.isOlympiad &&
                    !this.isBattle &&
                    this.answers.good >= this.parameters.amountOfExamples &&
                    !this.parameters.infinityAmountOfExamples
                ) {
                    this.gameEnd = true;
                }
            },
            wrongAnswer() {
                !this.isOlympiad && this.playResultSound('failure');
                ++this.answers.bad;
                this.correct = false;
                this.getLastNumbers = false;
                this.clearTimer();
            },
            playResultSound(result) {
                if (!this.isSingleScreen) {
                    return;
                }
                this.resultInstance = this.$createjs.Sound.play(result);
                this.resultInstance.volume = 0.6;
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.start();
                }
            },
            start() {
                if (this.resultInstance) {
                    this.resultInstance.stop();
                }
                this.counter = 1;
                if (this.parameters.extraOptions.music) {
                    this.bgMusicInstance = this.$createjs.Sound.play('music' + _.random(1, trainerConfig.music.length));
                    this.bgMusicInstance.on('complete', this.playRandomMusic, this);
                    this.bgMusicInstance.volume = 0.1;
                }
            },
            playRandomMusic() {
                this.bgMusicInstance.stop();
                this.bgMusicInstance = this.$createjs.Sound.play('music' + _.random(1, trainerConfig.music.length));
                this.bgMusicInstance.on('complete', this.playRandomMusic, this);
                this.bgMusicInstance.volume = 0.1;
            },
            increaseSpeed() {
                if (this.correct || this.parameters.dictation) {
                    this.wrongAnswersForSpeed = 0;
                    this.correctAnswersForSpeed++;
                    if (
                        this.correctAnswersForSpeed === this.parameters.tasksForSpeedUp &&
                        +(this.parameters.speed - this.parameters.speedUp).toFixed(1) >= 0.1
                    ) {
                        this.parameters.speed = +(this.parameters.speed - this.parameters.speedUp).toFixed(1);
                        this.correctAnswersForSpeed = 0;
                    }
                } else {
                    this.correctAnswersForSpeed = 0;
                    this.wrongAnswersForSpeed++;
                    if (
                        this.wrongAnswersForSpeed === this.parameters.tasksForSpeedUp &&
                        +(this.parameters.speed + this.parameters.speedUp).toFixed(1) <= this.minimalSpeed
                    ) {
                        this.parameters.speed = +(this.parameters.speed + this.parameters.speedUp).toFixed(1);
                        this.wrongAnswersForSpeed = 0;
                    }
                }
            },
            complicate() {
                if (this.correct || this.parameters.dictation) {
                    this.wrongAnswersForComplication = 0;
                    this.correctAnswersForComplication++;
                    if (
                        this.correctAnswersForComplication === this.parameters.tasksForComplication &&
                        this.parameters.amountOfActions + this.parameters.complication <= 100
                    ) {
                        this.parameters.amountOfActions += this.parameters.complication;
                        this.correctAnswersForComplication = 0;
                    }
                } else {
                    this.correctAnswersForComplication = 0;
                    this.wrongAnswersForComplication++;
                    if (
                        this.wrongAnswersForComplication === this.parameters.tasksForComplication &&
                        this.parameters.amountOfActions - this.parameters.complication >= 2
                    ) {
                        this.parameters.amountOfActions -= this.parameters.complication;
                        this.wrongAnswersForComplication = 0;
                    }
                }
            },
            clearTimer() {
                clearTimeout(this.timer);
                this.timer = null;
            },
            isAbacusOpened(val) {
                this.showAbacus = val;
            },
            stopGameEvent(value) {
                this.stopGame = value;
                if (this.isBattle) {
                    this.isOpponentAnswering = value;
                }
            },
            beforeTabClosed() {
                if (this.isStarted && this.user.type === 'student' && !this.isBattle) {
                    this.gameEnd = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
                return null;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
        },
        computed: {
            isOlympiad() {
                return this.gameType === 'olympiad';
            },
            ...mapState({
                user: state => state.auth.user,
            }),
            isX2() {
                if (this.parameters) {
                    return this.parameters.extraOptions.x2;
                }
                return false;
            },
            soundObjects() {
                if (this.parameters && this.parameters.playersNumber > 1) {
                    return;
                }
                let sounds = [];
                sounds.push(...trainerConfig.result);
                sounds.push(...trainerConfig.countdownSound);
                if (this.parameters && this.parameters.extraOptions.music) {
                    sounds.push(...trainerConfig.music);
                }
                if (this.parameters && !this.parameters.extraOptions.x2) {
                    sounds.push(...trainerConfig.digitsSounds[this.locale]);
                }
                return sounds;
            },
            locale() {
                if (this.user && this.user.locale) {
                    return this.user.locale;
                }
                return 'ru';
            },
            showSpeed() {
                return (
                    this.parameters.isSpeedIncrease &&
                    (this.stopGame || this.showTurtle) &&
                    (!this.parameters.extraOptions.motion || this.stopGame)
                );
            },
            showComplication() {
                return this.parameters.isComplication && (this.stopGame || this.showTurtle);
            },
            isSingleScreen() {
                return !this.playersNumber;
            },
            isGameEnded() {
                return this.examplesArray.length === this.parameters.amountOfExamples;
            },
            isCheckAnswersButtonAvailable: getIsCheckAnswersButtonAvailableComputed.call(this, 4),
            minDurationForVoiceActing() {
                if (this.user && this.user.locale === 'bg') {
                    return minDurationForVoiceActing.bulgarian;
                }
                if (this.user && this.user.locale === 'fr') {
                    return minDurationForVoiceActing.french;
                }
                if (this.user && this.user.locale === 'uk') {
                    return minDurationForVoiceActing.ukrainian;
                }
                if (this.user && this.user.locale === 'lv') {
                    return minDurationForVoiceActing.latvian;
                }
                if (this.user && this.user.locale === 'es') {
                    return minDurationForVoiceActing.spanish;
                }
                return minDurationForVoiceActing.englishAndRussian;
            },
            minimalSpeed() {
                return this.parameters.isMinimalSpeed ? this.initialSpeed : MINIMAL_SPEED;
            },
            multiplayerClass() {
                if (this.playersNumber === 1) {
                    return 'play-box__one-player';
                }
                if (this.playersNumber === 2) {
                    return 'play-box__two-players';
                }
                if (this.playersNumber === 3) {
                    return 'play-box__three-players';
                }
                if (this.playersNumber === 4) {
                    return 'play-box__four-players';
                }
                if (this.playersNumber === 5) {
                    return 'play-box__five-players';
                }
                if (this.playersNumber === 6) {
                    return 'play-box__six-players';
                }
                if (this.playersNumber === 7) {
                    return 'play-box__seven-players';
                }
                if (this.playersNumber === 8) {
                    return 'play-box__eight-players';
                } else {
                    return '';
                }
            },
            portalName() {
                return this.playersNumber >= 1 ? `exitButtons${this.place - 1}` : 'exitButtons';
            },
            gameDifficultForAbacus() {
                if (
                    this.parameters.jumpOver !== null &&
                    this.parameters.jumpOver.value === 100 &&
                    this.parameters.difficult === 'Однозначные цифры'
                ) {
                    return 'Двузначные цифры';
                }
                return this.parameters.difficult;
            },
            amountOfActionParameterForHeader() {
                if (this.showedActions === this.parameters.amountOfActions) {
                    return (this.showComplication && `${this.showedActions}/${this.parameters.amountOfActions}`) || '';
                } else {
                    return (
                        (this.showComplication && `${this.showedActions + 1}/${this.parameters.amountOfActions}`) || ''
                    );
                }
            },
            isCounterStarted() {
                return this.counter === 1;
            },
        },
        components: {
            ResultButtons,
            GamePreparationCounter,
            DigitsArea,
            GameInfo,
            GameHeader,
            ModalFrameForIndividualSettings,
            CalculatingAnswers,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';
    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        align-self: start;
        &_x2 {
            flex-direction: column-reverse;
        }
    }
    .play-box__result {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex-grow: 5;
    }
    .play-box__result-button {
        margin-top: 20px;
    }
    .result-image {
        @media screen and (max-width: 575px) {
            height: 300px;
            width: 140px;
        }
    }
    .play-box__example {
        width: 100%;
        display: flex;
        justify-content: center;
        &_x2 {
            margin-top: 50px;
            justify-content: space-around;
            position: relative;
            flex-direction: column;
            align-items: center;
            @include media($md) {
                flex-direction: row;
                align-items: stretch;
            }
        }
        &_second {
            width: 100%;
        }
    }
    .play-box__example-divider {
        position: static;
        width: 50%;
        transform: none;
        margin: 30px auto;
        @include media($md) {
            position: absolute;
            transform: rotate(90deg);
            width: 150px;
            top: 50%;
            background: $hsl-color-gray-53;
        }
    }
    .add-sub-with-time__bottom-button_two-buttons {
        display: flex;
        justify-content: center;
        margin-top: 40px;
        @media screen and (max-width: 575px) {
            flex-direction: column;
            align-items: center;
        }
    }
    .add-sub-with-time__bottom-button_three-buttons {
        display: flex;
        justify-content: center;
        margin-top: 40px;
        @media screen and (max-width: 991px) {
            flex-direction: column;
            align-items: center;
        }
    }
    .add-sub-with-time__show-answer-button {
        margin-right: 20px;
        @media screen and (max-width: 575px) {
            margin: 0 0 20px 0;
        }
    }
    .go-to-trainer-button {
        margin-left: 10px;
        @media screen and (max-width: 991px) {
            margin: 20px 0 0 10px;
        }
        @media screen and (max-width: 575px) {
            margin: 20px 0 0 0;
        }
    }
    .go-to-dashboard-button {
        @media screen and (max-width: 991px) {
            margin-top: 20px;
        }
        @media screen and (max-width: 575px) {
            margin: 0;
        }
    }
    .game-info__block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .exit-buttons {
        @media screen and (max-width: 575px) {
            display: flex;
            flex-direction: column;
        }
    }
    .play-box__answer-footer-x2 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 80px;
        @media screen and (max-width: 767px) {
            margin-top: 15px;
        }
    }

    .multiplayer-play-box {
        .play-box__game {
            height: 100%;
            flex-direction: column-reverse;
            justify-content: flex-end;
            align-items: center;
        }
    }
    .play-box__one-player,
    .play-box__two-players,
    .play-box__three-players,
    .play-box__four-players {
        .add-sub-with-time__bottom-button_two-buttons,
        .add-sub-with-time__bottom-button_three-buttons {
            flex-direction: column;
            align-items: center;
            margin-top: 10px;
            :first-child {
                margin: 0 0 10px 0;
            }
        }
    }
    .play-box__one-player,
    .play-box__two-players,
    .play-box__three-players {
        .exit-buttons .help-text__end-multiplayer-game {
            font-size: 20px;
            line-height: 30px;
            text-align: center;
        }
        .cs-button {
            width: 200px;
            font-weight: 500;
            &:first-child {
                margin-bottom: 5px;
            }
        }
    }
    .play-box__four-players,
    .play-box__five-players {
        .add-sub-with-time__bottom-button_two-buttons,
        .add-sub-with-time__bottom-button_three-buttons {
            flex-direction: row;
            @include media($xxl) {
                flex-direction: column;
            }
            margin-top: 20px;
            .add-sub-with-time__show-answer-button {
                margin: 0 10px 0 0;
                @include media($xxl) {
                    margin: 0 0 20px 0;
                }
            }
        }
        .help-text__end-multiplayer-game {
            font-size: 14px;
            text-align: center;
            margin: 5px 10px 0 0;
            line-height: 20px;
            @include media($xxl) {
                font-size: 18px;
            }
        }
        .cs-button {
            padding: 11px 30px;
            font-weight: 500;
            &:first-child {
                width: 200px;
                margin-bottom: 0;
            }
        }
    }
    .play-box__five-players,
    .play-box__six-players,
    .play-box__seven-players,
    .play-box__eight-players {
        .add-sub-with-time__bottom-button_two-buttons,
        .add-sub-with-time__bottom-button_three-buttons {
            flex-wrap: wrap;
            margin-top: 0;
            @include media($xl) {
                flex-direction: column;
            }
            .add-sub-with-time__show-answer-button {
                margin: 0 0 10px 0;
                @media screen and (min-width: 1600px) {
                    text-align: center;
                }
                @include media($xxl) {
                    margin: 0 15px 10px 0;
                }
            }
            &:last-child(-n + 2) {
                width: 420px;
                .add-sub-with-time__show-answer-button {
                    margin-right: 10px;
                    font-weight: 500;
                }
            }
        }
        .help-text__end-multiplayer-game {
            font-size: 14px;
            text-align: center;
            margin: -5px 10px 0 0;
            line-height: 20px;
            @include media($xxl) {
                font-size: 18px;
                margin: 0 10px 0 0;
            }
        }
        .cs-button {
            padding: 11px 30px;
            font-weight: 500;
            &:first-child {
                width: 200px;
                margin-bottom: 0;
                @include media($xxl) {
                    margin-right: 10px;
                }
            }
        }
    }
    .play-box__seven-players,
    .play-box__eight-players {
        .add-sub-with-time__bottom-button_two-buttons,
        .add-sub-with-time__bottom-button_three-buttons {
            &:last-child(-n + 2) {
                width: 420px;
            }
        }
        .help-text__end-multiplayer-game {
            font-size: 12px;
            margin: -5px 10px 0 0;
            line-height: 16px;
            @media screen and (min-width: 1600px) {
                font-size: 16px;
                line-height: 26px;
            }
        }
        .add-sub-with-time__show-answer-button {
            margin-right: 0 !important;
            font-weight: 500;
        }
        .cs-button {
            font-weight: 500;
            &:first-child {
                width: 200px;
                padding: 10px 20px;
            }
            @include media($xxl) {
                width: 190px !important;
                font-size: 16px;
                padding: 15px 30px;
            }
        }
    }
    .help-text__end-multiplayer-game {
        color: $hsl-color-green-58;
        font-weight: 500;
    }
</style>
